import React from 'react';
import classnames from 'classnames';
import {NeuroMessage, GuideProgress} from '@ignitesales/neuro-application/src/neuro-guide';
import PropTypes from 'prop-types';
import ProgressBar from './ProgressBar';

const Header = ({className}) => {
  const logoPath = "/classpath/assets/images/svg/logo-barksdale-new.svg";
  const classes = classnames('header', className);
  return (
    <header className={classes}>
      <div className="logo">
        <img src={logoPath} className="logo-image" />
      </div>
      <div className="guideContext">
        <NeuroMessage id="guide.name" tagName="span"/>
      </div>
      <div className="break"></div>
      <GuideProgress useOnlyOnSurveyPages={false} render={ ({ progress }) =>
        <ProgressBar className="progressBar" progress={progress} />
      } />
    </header>
  );
};

Header.propTypes = {
  className: PropTypes.string
};

export default Header;